import React from 'react';
import { translate, Trans } from 'react-i18next';
import { Icon, Segment, Header, Button, Container, Grid, Message } from 'semantic-ui-react';

import Instructions from '../Instructions.js';
import ChallengeUtils  from 'utils/ChallengeUtils.js';
import Utils from 'utils/Utils.js';
import DigitalTimer from '../DigitalTimer.js';
import {colors, fontSizes, fonts, shadow, spacings} from 'style';
import styleDef from './style.js'

var style= {
    ...styleDef,
    containerExpanded: {
        padding:'0px 10px 0px 10px',
    },
    body: {
        minHeight: '205px',
    },
    addButton: {
        width: '40px',
        height:'40px',
        padding:'0px',
        position: 'relative',
        top: '-12px',
        left: '20px',
    },
    addButtonIcon: {
        margin: '0px',
        color: '#fff',
        fontWeight: 'normal',
    },
    message: {
        padding: '.78571429em 1.5em .78571429em',
        fontSize: '1rem',
        lineHeight: '1em'
    },
    header: {
        color: colors.themeTeal,
        fontSize: '2em',
        fontWeight: 'normal',
    },
    count: {
        color: colors.themeTeal,
        fontSize: '3em',
        lineHeight: '60px',
    },
    timerWrapper: {
        paddingBottom: '40px',
    },
    message: {
        fontWeight: 'normal',
        ...fonts.body,
        lineHeight: '1',
        borderRadius: '100px',
        backgroundColor: colors.themeBlue,
        color: '#fff',
        width: '100%',
        maxWidth: '300px',
        marginLeft: 'auto',
        marginRight: 'auto',
        boxShadow: 'none',
        marginBottom: spacings.base,
        padding: '.78571429em 1.5em .78571429em',
    },
};

const AllDay= ({t, challenge, timeRemaining, error, onComplete, withMax, userChallenge}) => (
    <Container style={{...style.container, ...style.containerExpanded}}>
    <div style={style.containerDiv}>
        <Segment style={style.segment}>
            <Grid style={style.grid} centered columns={1}>
                <Grid.Row verticalAlign='top' style={style.topRow}>
                    <Grid.Column verticalAlign='top'>
                        <div style={{...style.imageBanner, backgroundImage:Utils.url(ChallengeUtils.getChallengeImageUrl(challenge))}}/>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column verticalAlign='top'>
                        <div style={style.body}>
                            <Instructions challenge={challenge} />
                            <Header style={style.header}>
                                {t('Your Count')}
                            </Header>
                            <Header>
                                <div style={style.count}>{Utils.deref(challenge,'userChallenge.actionsCompleted', 0)}
                                {Boolean(!(withMax && userChallenge && userChallenge.state==1)) &&
                                    <Button style={style.addButton} circular color='teal' onClick={()=>{onComplete(challenge.id, {})}}>
                                        <Icon style={style.addButtonIcon} className='icon-plus'/>
                                    </Button>
                                }
                                </div>
                                {Boolean(userChallenge && userChallenge.state==1) &&
                                    <div style={style.message}>{t('Milestone Reached')}</div>
                                }
                            </Header>
                        {!error &&
                            <div style={style.timerWrapper}>
                                <Header>{t('Time Remaining')}</Header>
                                <DigitalTimer time={timeRemaining} formatStr='HH:mm:ss'  />
                            </div>
                        }
                        {error &&
                            <Message negative>
                                <Message.Header>{t('Error')}</Message.Header>
                                <p>{error}</p>
                            </Message>
                        }
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='bottom' />
            </Grid>
        </Segment>
    </div>
    </Container>
);

export default translate('challenges')(AllDay);



// WEBPACK FOOTER //
// ./src/modules/challenges/types/screens/AllDay.js